import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "container p-0 mt-2" }
const _hoisted_2 = ["aria-labelledby", "aria-describedby"]
const _hoisted_3 = { class: "col-10" }
const _hoisted_4 = ["required", "name", "id", "value", "disabled"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 0,
  class: "input-group-append"
}
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "row",
      role: "radiogroup",
      "aria-labelledby": _ctx.ids.label,
      "aria-describedby": _ctx.describedBy
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.radioButtonOptions, (option, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "form-check form-check-inline"
          }, [
            _withDirectives(_createElementVNode("input", {
              onChange: _cache[0] || (_cache[0] = ($event: any) => ($options.radioButtonChanged())),
              class: "form-check-input",
              type: "radio",
              required: $props.element.required,
              name: 'radio'+$props.element.name,
              id: _ctx.ids.option(index),
              value: option.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.elData.value) = $event)),
              disabled: $props.hidden
            }, null, 40, _hoisted_4), [
              [_vModelRadio, $data.elData.value]
            ]),
            _createElementVNode("label", {
              class: "form-check-label",
              for: _ctx.ids.option(index)
            }, _toDisplayString($options.getTextFor(option.text,$props.lang)), 9, _hoisted_5),
            ($data.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("div", {
                      class: "spinner-border spinner-border-sm",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Laden...")
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "invalid-feedback",
          id: _ctx.ids.error,
          style: _normalizeStyle(_ctx.invalidStyle)
        }, _toDisplayString($options.getTextFor($props.element.invalid,$props.lang)), 13, _hoisted_7),
        (_ctx.heeftUitleg)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: _ctx.ids.help,
              class: "form-text"
            }, _toDisplayString($options.getTextFor($props.element.explanation, $props.lang)), 9, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_2)
  ], 512)), [
    [_vShow, !$props.hidden]
  ])
}